import React from "react";
import { HighlightedTextProps } from "@/types/redlines";

export const HighlightedText: React.FC<HighlightedTextProps> = ({ diffWords }) => {
  return (
    <span>
      {diffWords.map((part, index) => (
        <React.Fragment key={`${part.value}-${index}`}>
          {part.removed && (
            <span
              style={{
                textDecoration: "line-through",
                color: "red",
                padding: "0 2px",
              }}
            >
              {part.value}
            </span>
          )}
          {part.added && (
            <span
              style={{
                backgroundColor: "#2ea04366",
                padding: "0 2px",
                borderRadius: "2px",
                fontWeight: "normal",
              }}
            >
              {part.value}
            </span>
          )}
          {!part.removed && !part.added && part.value}
        </React.Fragment>
      ))}
    </span>
  );
};
